module.exports = __webpack_public_path__ + "static/media/1-en.c4b4d04a.svg";